import React from 'react';
import DateSelector from './DateSelector';


export default function VersionDetailSelect({
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    description,
    setDescription,
    target,
    setTarget
}) {
    return (
        <div className="ml-5 p-5 mb-4 bg-white shadow">
            <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md mb-5">Add Version Details</h2>
            <DateSelector
                fromDate={fromDate}
                setFromDate={setFromDate}
                toDate={toDate}
                setToDate={setToDate}
                target={target}
                setTarget={setTarget}
            />
            <div className="mb-4 px-6">
                <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="description">
                    Version Description
                </label>
                <input value={description} onChange={(e) => setDescription(e.target.value)} className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline" id="description" type="text" placeholder="Description..." />
            </div>
        </div>
    )
}